import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import { Layout } from "./components/Layout";

import Home from "./pages/Home";
import Vault from "./pages/Vault";
import PropertyDetail from "./pages/PropertyDetail";
import Valuation from "./pages/Valuation";
import Boarding from "./pages/Boarding";
import GlobalBridge from "./pages/GlobalBridge";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import FlipCommand from "./pages/FlipCommand";
import Pricing from "./pages/Pricing";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Marketplace from "./pages/Marketplace";
import CadetAcademy from "./pages/CadetAcademy";
import BrokerPortal from "./pages/BrokerPortal";
import AdmiralCommand from "./pages/AdmiralCommand";
import Scouter from "./pages/Scouter";
import Fractional from "./pages/Fractional";
import FractionalPortfolio from "./pages/FractionalPortfolio";
import BrokerDashboard from "./pages/BrokerDashboard";
import CurrencyBridge from "./pages/CurrencyBridge";
import ImperialArchives from "./pages/ImperialArchives";
import JuniorLogin from "./pages/JuniorLogin";
import JuniorCommand from "./pages/JuniorCommand";
import SovereignRescue from "./pages/SovereignRescue";
import PillarPage from "./pages/PillarPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/vault/:id" element={<PropertyDetail />} />
              <Route path="/valuation" element={<Valuation />} />
              <Route path="/boarding" element={<Boarding />} />
              <Route path="/global-bridge" element={<GlobalBridge />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/flip-command" element={<FlipCommand />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/broker-portal" element={<BrokerPortal />} />
              <Route path="/admiral" element={<AdmiralCommand />} />
              <Route path="/scouter" element={<Scouter />} />
              <Route path="/fractional" element={<Fractional />} />
              <Route path="/fractional/portfolio" element={<FractionalPortfolio />} />
              <Route path="/broker/dashboard" element={<BrokerDashboard />} />
              <Route path="/currency-bridge" element={<CurrencyBridge />} />
              <Route path="/imperial-archives" element={<ImperialArchives />} />
              <Route path="/junior" element={<JuniorLogin />} />
              <Route path="/junior/command" element={<JuniorCommand />} />
              <Route path="/rescue" element={<Navigate to="/affiliates" replace />} />
              <Route path="/affiliates" element={<SovereignRescue />} />
              <Route path="/academy" element={<CadetAcademy />} />
              <Route path="/cadet-academy" element={<Navigate to="/academy" replace />} />
              <Route path="/relocation"  element={<PillarPage pillarId="relocation" />} />
              <Route path="/real-estate" element={<PillarPage pillarId="real-estate" />} />
              <Route path="/finance"     element={<PillarPage pillarId="finance" />} />
              <Route path="/logistics"   element={<PillarPage pillarId="logistics" />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: '#0A0A0A',
              color: '#F5F5F5',
              border: '1px solid rgba(212, 175, 55, 0.3)',
              borderRadius: 0,
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '12px',
              letterSpacing: '0.05em',
            }
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
